<div class="modal-body">
  <i class="fa fa-info-circle" aria-hidden="true"></i>&nbsp;
  <b>View 8858 Data/Produce Forms</b>
  <br><br>
</div>
